import styled from 'styled-components';

export const MiniRadio = styled.label<{
    $checked: boolean;
    $disabled?: boolean;
    $rightCheckbox?: boolean;
    $flexLabel?: boolean;
    $round?: boolean;
    $coreColor?: string;
    $hardwareRadioFix?: boolean;
}>`
    position: relative;
    padding-left: 25px;
    cursor: ${({$disabled = false}) => ($disabled ? 'initial' : 'pointer')};
    display: ${({$rightCheckbox = false, $flexLabel = false}) =>
        $rightCheckbox ? 'block' : $flexLabel ? 'flex' : 'initial'};

    &:before {
        position: absolute;
        content: '';
        width: 16px;
        height: 16px;
        top: 3px;
        border: 1px solid ${({theme}) => theme.colors.primary.main};
        box-shadow: 0px 0px 2px 0px rgb(0 0 0 / 75%) inset;
        opacity: ${({$disabled = false}) => ($disabled ? '0.5' : 1)};
        border-radius: ${({$round = false}) => ($round ? '50%' : 'initial')};

        ${({$rightCheckbox = false}) => {
            if ($rightCheckbox) {
                return 'right: 0;';
            } else {
                return 'left: 0;';
            }
        }}
    }

    &:after {
        display: ${({$checked}) => ($checked ? 'block' : 'none')};
        position: absolute;
        content: '';
        width: 8px;
        height: 8px;
        top: 7px;
        background: ${({theme, $coreColor}) =>
            $coreColor || theme.colors.secondary.main};
        border-radius: ${({$round = false}) => ($round ? '50%' : 'initial')};

        ${({$rightCheckbox = false}) => {
            if ($rightCheckbox) {
                return 'right: 4px;';
            } else {
                return 'left: 4px;';
            }
        }}
    }

    > input {
        display: none;
    }
`;
